import type { RequestOptions } from 'searchkit';

import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const requestOptions: RequestOptions = {
  getBaseFilters: () => [
    {
      bool: {
        must: {
          term: {
            type: {
              value: 'article',
            },
          },
        },
      },
    },
  ],
};

export const sorting: SearchkitWrapperProps['searchSettings']['sorting'] = {
  default: {
    field: 'created',
    order: 'desc',
  },
};
